export class CardTypeGraphicTemplateApiModel {
  templateId: string;

  graphic: string;
}
